// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\SharingToken\ApiSharingToken.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Share, ShareData, ShareOptions } from 'data/models/Share';

// SharingTokenData is the class that SharingToken serializes to/from
export interface SharingTokenData {
    Id : number;
	
    Shares : ShareData[] | null;
    SharesUrl : string | null;
	
}

// SharingTokenOptions is the class which may be passed to the SharingToken constructor to define optional initial data values
export interface SharingTokenOptions {
    Id : number;
	
    Shares? : ShareOptions[] | null;
    SharesUrl? : string | null;
	
}

export class SharingToken {
    public Id : DataSignal<number>;
	
    public Shares : SDataArray<Share>;
    public SharesUrl : DataSignal<string | null>;
	

    constructor();
    constructor(data : SharingTokenOptions);
    constructor(data: SharingTokenOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Shares = SArray<Share>([]);
        this.SharesUrl = jsonableObservable(S.value<string | null>(data && data.SharesUrl !== undefined ? data.SharesUrl : null));
	    
    }

    static key(obj : SharingToken) {
        return obj.Id();
    }
    
    static dataKey(obj : SharingTokenOptions) {
        return obj.Id;
    }

    static update(obj : SharingToken, data : SharingTokenOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.SharesUrl !== undefined) obj.SharesUrl(data.SharesUrl);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/SharingToken.ts